
export const TransformLovToOption = (list, sameAsValue?: boolean) => {
	return list.map(a => { return { value: a.val, text: a.hum && a.hum.length > 0 && !sameAsValue ? a.hum : a.val }; });
};

export const getRequiredText = (format: string, label: string) => {
	if (!format) {
		return 'Required';
	}
	return format.replace('{0}', label);
};

export const getMaritalStatusText = (status: string) => {	
	if (status === 'M') {
		return 'Married';
	}
	if (status === 'W') {
		return 'Widow';
	}
	if (status === 'D') {
		return 'Divorced';
	}

	return 'Single';
};

export const getFormatedPhone = (area, phone) => {
    if (!phone) return '';

	return `${area}${phone}`;
};

export const getNumberPercent = (percent: number) => {
	if (!percent) {
		return null;
	}

	return `${percent}%`;
};


export const getFormattedCityStatePostal = (city: string, state: string, postal: string) : string => {
    return `${city}, ${state}, ${postal}`;
};

export const getDollarValue = (dollar: number) => {
	return dollar ? `$${dollar?.toLocaleString()}` : dollar;
};